import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#F5F5F5"
  }} d="M473.7,88.3H38.3C17.1,88.3,0,105.5,0,126.6v258.8c0,21.2,17.2,38.3,38.3,38.3h435.3  c21.2,0,38.3-17.2,38.3-38.3V126.6C512,105.4,494.8,88.3,473.7,88.3z" /><g><path style={{
      fill: "#FF4B55"
    }} d="M0,385.4c0,21.2,17.2,38.3,38.3,38.3h435.3c21.2,0,38.3-17.2,38.3-38.3v-14.6H0V385.4z" /><path style={{
      fill: "#FF4B55"
    }} d="M473.7,88.3H38.3C17.1,88.3,0,105.5,0,126.6v14.6h512v-14.6C512,105.4,494.8,88.3,473.7,88.3z" /></g><rect y={194.2} style={{
    fill: "#41479B"
  }} width={512} height={123.6} /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };